import React from "react";

import { CrossSellBase } from "./CrossSellBase";
import { Gusto } from "@puzzle/icons";
import { externalBrandColors } from "@puzzle/theme";
import { Route } from "lib/routes";
import links from "lib/links";

// logo size expands the square svg to be a size that
// makes the logo appear properly in the logo container
// the top and bottom of the svg, which have no content,
// are cut off by the container so that just the logo appears
// in the container
const GUSTO_LOGO_SIZE = 220;

export const CrossSellGusto = () => {
  return (
    <CrossSellBase
      logo={<Gusto size={GUSTO_LOGO_SIZE} fill={externalBrandColors.gusto.logoBackground} />}
      title="Set up your payroll in Puzzle"
      description="We partner with leading payroll providers to make your payroll accounting effortless."
      line1Actions={[
        {
          text: "Sign up",
          link: links.crossSell.gustoSignup,
          external: true,
          buttonVariant: "primary",
        },
        {
          text: "Connect my payroll provider",
          link: Route.integrations,
          external: false,
          buttonVariant: "secondary",
        },
      ]}
      line2Actions={[
        {
          text: "See other offers",
          link: links.partnerRewards,
          external: true,
        },
      ]}
    />
  );
};
